import { Link } from "react-router-dom";
import { BookOpen, X } from "lucide-react";
import { useModuleHelp } from "../../context/ModuleHelpContext";
import { docsHref } from "../../lib/docsCatalog";

export function ModuleHelpRail({ className = "" }) {
  const { config, panelEnabled, setPanelEnabled, sectionId, setSectionId, activeSection } =
    useModuleHelp();

  if (!panelEnabled) return null;

  const sectionHref =
    activeSection.docId != null
      ? docsHref(activeSection.docId, activeSection.docAnchor ?? "")
      : docsHref(config.docId);

  return (
    <aside
      className={`rounded-2xl border border-brand-accent/20 bg-brand-soft/40 p-4 space-y-3 shadow-sm ${className}`}
      aria-label="Ayuda contextual"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-widest text-brand-dark/45">
            Ayuda en pantalla
          </p>
          <h2 className="text-sm font-bold text-brand-dark leading-snug">{activeSection.title}</h2>
        </div>
        <button
          type="button"
          onClick={() => setPanelEnabled(false)}
          className="p-1 rounded-lg text-brand-dark/40 hover:text-brand-dark hover:bg-white/80"
          aria-label="Cerrar panel de ayuda"
        >
          <X size={16} />
        </button>
      </div>

      <ul className="space-y-2 text-xs text-brand-dark/80 leading-relaxed list-disc pl-4">
        {activeSection.bullets.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>

      <Link
        to={sectionHref}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-primary hover:underline"
      >
        <BookOpen size={14} />
        Ver manual completo
      </Link>

      {Object.keys(config.sections).length > 1 && (
        <div className="pt-2 border-t border-brand-accent/15">
          <p className="text-[10px] font-bold uppercase tracking-widest text-brand-dark/40 mb-1.5">
            Temas
          </p>
          <div className="flex flex-wrap gap-1">
            {Object.values(config.sections).map((sec) => (
              <button
                key={sec.id}
                type="button"
                onClick={() => setSectionId(sec.id)}
                className={`px-2 py-0.5 rounded-md text-[10px] font-semibold border transition-colors ${
                  sec.id === sectionId
                    ? "border-brand-primary bg-white text-brand-primary"
                    : "border-transparent bg-white/60 text-brand-dark/55 hover:border-brand-soft"
                }`}
              >
                {sec.title}
              </button>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
}
